// extracted by mini-css-extract-plugin
export default {"cls1":"wpNEuNsCU7XvsPSZkxmQ","cls2":"PFnkEZWEiWssD8mquR_i wpNEuNsCU7XvsPSZkxmQ"};